import RequesterV1 from "@/components/api/v1/requester.js";

const BASE_PATH = "customer/quality_reports/container_provider/show_process";

export default {
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${customer_id}/agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchRejectedPercentage(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${customer_id}/rejected_percentage_weekly/${agro_exporter_process_id}`
    );
  },

  fetchTopDefects(customer_id, agro_exporter_process_id, provider_id = null) {
    const basePath = `${BASE_PATH}/${customer_id}/top_defects/${agro_exporter_process_id}`;
    const path = provider_id ? `${basePath}/${provider_id}` : basePath;
    return RequesterV1.get(path);
  },

  fetchSummary(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${customer_id}/summary/${agro_exporter_process_id}`
    );
  },

  fetchIndicators(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${customer_id}/indicators/${agro_exporter_process_id}`
    );
  },

  fetchProvidersEfficiency(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${customer_id}/providers_efficiency/${agro_exporter_process_id}`
    );
  },

  fetchProvidersByInspector(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${customer_id}/providers_by_inspector/${agro_exporter_process_id}`
    );
  },
  fetchProvidersRejectedAttributeCategory(
    customer_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `${BASE_PATH}/${customer_id}/providers_rejected_attribute_category/${agro_exporter_process_id}`
    );
  },

  fetchQuarterlyReport(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${customer_id}/quarterly_report/${agro_exporter_process_id}`
    );
  }
};
